(function () {
  var GIFT_VARIANT_ID = 00000050340806164757; // 1ct Lab Grown Diamond Earrings
  var THRESHOLD_CENTS = 20000000; // $2000.00
  var GIFT_PROPERTY_KEY = '_free_gift';
  var ELIGIBLE_PRODUCT_TYPES = ['Engagement Rings']; // only these count toward the $2000 and unlock the gift
  var RING_BUILDER_PROPERTY_KEY = '_ring_builder'; // Custom Ring builder lines (setting + diamond) count too
  var checking = false;

  function isGiftLine(item) {
    return item.variant_id === GIFT_VARIANT_ID && item.properties && item.properties[GIFT_PROPERTY_KEY] === 'true';
  }

  function isEligibleLine(item) {
    if (isGiftLine(item)) return false;
    return ELIGIBLE_PRODUCT_TYPES.indexOf(item.product_type) !== -1 ||
      Boolean(item.properties && item.properties[RING_BUILDER_PROPERTY_KEY]);
  }

  function getCartItemsElement() {
    return document.querySelector('cart-items');
  }

  function getSectionsToRender(cartItemsEl) {
    if (!cartItemsEl || typeof cartItemsEl.getSectionsToRender !== 'function') return [];
    try {
      return Array.from(new Set(
        cartItemsEl.getSectionsToRender()
          .filter(function (item) { return Boolean(document.querySelector('#' + item.id)); })
          .map(function (item) { return item.section; })
      )).filter(Boolean).slice(0, 5);
    } catch (e) {
      return [];
    }
  }

  function addGift() {
    var cartItemsEl = getCartItemsElement();
    var sections = getSectionsToRender(cartItemsEl);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _free_gift: 'true' } }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          console.error('free-gift: add failed', data.description || data.message);
          return;
        }
        if (cartItemsEl && typeof cartItemsEl.renderContentsAndDependencies === 'function' && data.sections) {
          cartItemsEl.renderContentsAndDependencies(data, null);
        }
      })
      .catch(function (e) { console.error('free-gift: add error', e); })
      .finally(function () { checking = false; });
  }

  function removeGift(lineIndex) {
    var cartItemsEl = getCartItemsElement();

    if (cartItemsEl && typeof cartItemsEl.updateQuantity === 'function') {
      cartItemsEl.updateQuantity(lineIndex, 0);
      checking = false;
      return;
    }

    fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    })
      .catch(function (e) { console.error('free-gift: remove error', e); })
      .finally(function () { checking = false; });
  }

  function keepOneGift(giftLines) {
    // Lines split by a discount share one key, so set quantities per key, not per line.
    var updates = {};
    giftLines.forEach(function (item) { if (!(item.key in updates)) updates[item.key] = 0; });
    updates[giftLines[0].key] = 1;
    fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () {
        if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
      })
      .catch(function (e) { console.error('free-gift: dedupe error', e); })
      .finally(function () { checking = false; });
  }

  function syncFreeGift() {
    if (checking) return;
    checking = true;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var giftLines = [];
        var giftLineIndex = null;

        cart.items.forEach(function (item, idx) {
          if (isGiftLine(item)) {
            giftLines.push(item);
            if (giftLineIndex === null) giftLineIndex = idx + 1;
          }
        });
        var giftQuantity = giftLines.reduce(function (sum, item) { return sum + item.quantity; }, 0);

        var qualifyingSubtotal = cart.items.reduce(function (sum, item) {
          return isEligibleLine(item) ? sum + item.line_price : sum;
        }, 0);

        var qualifies = qualifyingSubtotal >= THRESHOLD_CENTS;

        if (qualifies && !giftLines.length) {
          addGift();
          return;
        }
        if (!qualifies && giftLines.length) {
          removeGift(giftLineIndex);
          return;
        }
        // A reload while the gift was being added can add it twice (as a second
        // line, or quantity 2); keep exactly one.
        if (qualifies && giftQuantity !== 1) {
          keepOneGift(giftLines);
          return;
        }
        checking = false;
      })
      .catch(function (e) {
        checking = false;
        console.error('free-gift: sync failed', e);
      });
  }

  // Detect cart mutations triggered anywhere in the theme (add to cart, quantity change, remove, clear)
  var CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var isMutation = CART_MUTATION_PATTERN.test(url);
    var result = originalFetch.apply(this, args);
    if (isMutation) {
      result.then(function () {
        setTimeout(syncFreeGift, 350);
      }).catch(function () {});
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFreeGift);
  } else {
    syncFreeGift();
  }
})();
